import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { EERIE } from 'HubStyleTokens/colors';
import { EPSurveyWrapper } from './EPSurveyWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EPSurveyThankyouContainer = ({
  closeFeedbackBadge
}) => {
  return /*#__PURE__*/_jsx(EPSurveyWrapper, {
    width: 323,
    children: /*#__PURE__*/_jsxs(UICardWrapper, {
      compact: true,
      children: [/*#__PURE__*/_jsx(UICardSection, {
        className: "p-y-2",
        children: /*#__PURE__*/_jsx(UICloseButton, {
          color: EERIE,
          onClick: () => {
            closeFeedbackBadge();
          },
          size: "medium"
        })
      }), /*#__PURE__*/_jsx(UICardSection, {
        className: "p-bottom-4",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(UIIllustration, {
            className: "m-right-2",
            height: 72,
            name: "nps-question-thank-you"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "epAmplitudeSurvey.feedback.thankYou"
          })]
        })
      })]
    })
  });
};
export default EPSurveyThankyouContainer;